import { GetStaticPaths, GetStaticProps } from "next";
import { LandingPage } from "@/routes/Unauth/LandingPage";
import { LandingPageContent, SUPPORTED_LOCALES, Locale } from "@/constants/landingPages";

interface GoodBarberLandingPageProps {
  locale: Locale;
  content: LandingPageContent;
}

export default function GoodBarberLandingPage({ locale, content }: GoodBarberLandingPageProps) {
  return <LandingPage locale={locale} platform="goodbarber" content={content} />;
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths = SUPPORTED_LOCALES.map((locale) => ({
    params: { locale },
  }));

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps: GetStaticProps<GoodBarberLandingPageProps> = async ({ params }) => {
  const locale = params?.locale as Locale;

  try {
    // Dynamically load content for the given locale
    const content = await import(`@/content/landing/${locale}/goodbarber.json`);

    return {
      props: {
        content: content.default as LandingPageContent,
        locale,
      },
    };
  } catch (error) {
    // If content for locale doesn't exist, fallback to Slovak
    const content = await import(`@/content/landing/sk/goodbarber.json`);

    return {
      props: {
        content: content.default as LandingPageContent,
        locale,
      },
    };
  }
};
